import { Action } from 'redux';

// --------------
// Actions
// --------------
export enum LOADER_ACTIONS {
  SHOW = 'LOADER_ACTIONS/SHOW',
  HIDE = 'LOADER_ACTIONS/HIDE',
}

// --------------
// Action types
// --------------

export type IShowLoader = Action<LOADER_ACTIONS.SHOW>;
export type IHideLoader = Action<LOADER_ACTIONS.HIDE>;

export type ILoaderActions = IShowLoader | IHideLoader;

// --------------
// Action creators
// --------------

export const showLoader = (): IShowLoader => {
  return {
    type: LOADER_ACTIONS.SHOW,
  };
};

export const hideLoader = (): IHideLoader => {
  return {
    type: LOADER_ACTIONS.HIDE,
  };
};
